import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <article className="group">
      <Link
        to={`/comic/${comic.id}`}
        className="block overflow-hidden rounded-2xl bg-background-100 border border-background-200 transition-transform duration-300 hover:-translate-y-1"
        aria-label={`阅读漫画《${comic.title}》`}
      >
        <div className="relative aspect-[3/4] w-full overflow-hidden">
          <img
            src={comic.cover}
            alt={`${comic.title} 漫画封面 - ${comic.category}韩漫`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-2 top-2 inline-flex items-center gap-1 rounded-full bg-background-950/70 px-2.5 py-1 text-xs text-background-50 backdrop-blur">
            {comic.status}
          </span>
          <span className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-full bg-primary-500/90 px-2 py-1 text-xs font-semibold text-background-50">
            <i className="ri-star-fill text-[10px]"></i> {comic.rating.toFixed(1)}
          </span>
          <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-background-950/80 to-transparent"></div>
          <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between text-xs text-background-100">
            <span className="inline-flex items-center gap-1">
              <i className="ri-eye-line"></i> {comic.views}
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-file-list-3-line"></i> {comic.chapters}话
            </span>
          </div>
        </div>
        <div className="p-3 md:p-4">
          <h3 className="truncate text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
            {comic.title}
          </h3>
          <p className="mt-1 truncate text-xs text-foreground-500">{comic.author}</p>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {comic.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-800"
              >
                {tag}
              </span>
            ))}
            <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
              {comic.category}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
}